const awayNotices = [
  {
    id: "michael",
    className: "michaelAway",
    message: "Michael will be away from August 4 to August 17.",
    endsAt: "2026-08-18T00:00:00-07:00",
  },
  {
    id: "eliska",
    className: "eliskaAway",
    message: "Eliska will be away until July 21.",
    endsAt: "2026-07-22T00:00:00-07:00",
  },
];

export const getActiveAwayNotices = (now = new Date()) =>
  awayNotices.filter(({ endsAt }) => now < new Date(endsAt));
